import Axios from "axios";
import { SET_LEAD_INTEREST_ROUTES_LIST, UNSET_LEAD_INTEREST_ROUTES_LIST } from "@/store/mutation-types";
import { saveUpdateSalesLeadInterest, getSalesLeadInterest } from "@/store/api";
// initial state
const state = {
    getSalesLeadInterest: [],
    editingSalesLeadInterest: null,
};

const getters = {
    getSalesLeadInterest(state) {
        return state.getSalesLeadInterest;
    },
    getEditingSalesLeadInterest: (state) => state.editingSalesLeadInterest,
};

const mutations = {
    [SET_LEAD_INTEREST_ROUTES_LIST](state, data) {
        state.getSalesLeadInterest = data;
    },
    [UNSET_LEAD_INTEREST_ROUTES_LIST](state) {
        state.getSalesLeadInterest = [];
    },
    setEditingSalesLeadInterest(state, lead) {
        state.editingSalesLeadInterest = lead;
    },
};

const actions = {
    saveUpdateSalesLeadInterest({ commit }, data) {
        commit("SET_LOADING", { color: "primary" });
        return new Promise((resolve, reject) => {
            Axios.post(saveUpdateSalesLeadInterest, data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
        });
    },

    getSalesLeadInterest({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.get(getSalesLeadInterest, data)
                .then(function (response) {
                    commit("SET_LEAD_INTEREST_ROUTES_LIST", response.data.data);
                    resolve(response);
                })
                .catch(function (error) {
                    commit("UNSET_LEAD_INTEREST_ROUTES_LIST");
                    reject(error);
                })
                .then((always) => { });
        });
    },

    getSalesLeadInterestById({ commit }, data) {
        const getSalesLeadInterestById = `${getSalesLeadInterest}/${data}`;
        commit("SET_LOADING", { color: "primary" });
        return new Promise((resolve, reject) => {
            Axios.get(getSalesLeadInterestById)
                .then((response) => {
                    resolve(response.data.code);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
